import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { GeneralInfo } from 'app/shared/models/general-info.model';
import { GeneralInformationService } from 'app/entities/details/generalinformation/general-information.service';

@Component({
  templateUrl: './update-general-info.component.html',
  providers: [GeneralInformationService],
})

/**
 * Dialog component to update task definition description through editor.
 */
export class UpdateGeneralInfoComponent implements OnInit {
  generalInfoEditorForm: FormGroup;
  argGeneralInfoDetailsData: string;
  argId: number;
  entityTypeId: number;
  argEntityType: string;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private generalInformationService: GeneralInformationService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.updateTaskDetailsDataForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.generalInfoEditorForm = this.formBuilder.group({
      generalInfoText: [{ value: "" }],
    });
  }

  // Method to update task values and display in the dialog.
  updateTaskDetailsDataForm(): void {
    this.entityTypeId = this.argId;
    if (this.argGeneralInfoDetailsData) {
      this.generalInfoEditorForm.patchValue({
        generalInfoText: this.argGeneralInfoDetailsData,
      });
    }
  }

  // Method to submit the changes for Task Guide text.
  onSubmit({ value, valid }) {
    this.generalInfoEditorForm.disable();
    const generalInfoModel = new GeneralInfo();
    generalInfoModel.entityTypeId = this.entityTypeId;
    generalInfoModel.generalInfo = value.generalInfoText;
    this.generalInformationService.updateGeneralInformationDescription(generalInfoModel, this.argEntityType)
      .subscribe(response => {
        if (response.flagResult) {
          this.dialogRef.close(generalInfoModel);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.PERFORM_GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
          this.trackingService
            .emitEvent(
            TrackingConstants.GENERAL_INFO_TEXT_UPDATE,
            TrackingConstants.PERFORM_GENERAL_INFO_TEXT_UPDATE,
            TrackingConstants.FAILURE, 0);
          this.callSnackBarService(err);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.GENERAL_INFO_TEXT_UPDATE_SUCCESS,
      MessageService.GENERAL_INFO_TEXT_UPDATE_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.generalInfoEditorForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/generalinformation/updategeneralinformation/update-general-info.component.ts